import announcementBanner from "../actions/announcementBanner";
import navToggle from "../actions/navToggle";
import subMenuToggle from "../actions/subMenuToggle";

/**
 * header.js
 *
 * Functionality related to the site header
 *
 *
 * @param $ jQuery
 */
const Header = ($) => {
	navToggle($);
	subMenuToggle($);
	announcementBanner($);
};

export default Header;
